<template>
  <Page bg_color="bg-white">
    <v-img
      cover
      :src="login_bg_url"
      gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    >
      <!-- https://www.vuescript.com/vue-js-component-particles-backgrounds/ -->
      <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="particles-bg-js"
      >
      </vue-particles>
      <CenterPageColumn :outlined="false" :has_nav_bar="true">
        <CenterNavbar
          :crumps="[]"
          title=""
          :width_class="page_info.center_width_class"
          bg_color=""
        ></CenterNavbar>
        <ContactPageBanner
          bg_url=""
          :has_nav_bar="true"
          id="login_form_top"
          logo_class="logo-bg2"
        ></ContactPageBanner>
        
        <LoginComponent
          :is_loading="is_loading"
          @set-user="user => $emit('set-user',user)"
          @on-hide-loader="$emit('on-hide-loader')"
          @on-show-loader="$emit('on-show-loader')"
          @login-success="login_success"
        ></LoginComponent>
      </CenterPageColumn>
    </v-img>

    <v-row class="ma-0 pa-0 bg-footer" no-gutters>
      <v-col cols="2" class="ma-0 pa-0 wrapper-bg" no-gutters></v-col>
      <v-col class="ma-0 pl-0 bg-footer" no-gutters>
        <Footer
          :is_loading="is_loading"
          @on-hide-loader="$emit('on-hide-loader')"
          @on-show-loader="$emit('on-show-loader')"
        ></Footer>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0 wrapper-bg" no-gutters></v-col>
    </v-row>
  </Page>
</template>


<script>
import Page from "./../../components/Page";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import ContactPageBanner from "./../../components/ContactPageBanner";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import Footer from "./../../components/CenterFooter";

import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
import LoginComponent from "./../../components/LoginComponent";

export default {
  name: "Login",
  components: {
    Page,
    CenterPageColumn,
    CenterNavbar,
    ContactPageBanner,
    Footer,
    LoginComponent
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "login",
    login_bg_url:
      "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1602788555/botswana%20services/website%20assets/login_bg_qmbfxp.png",
    page_info: page_info,
    prevRoute: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  mounted() {
    //https://stackoverflow.com/questions/54770883/how-to-navigate-to-different-section-in-the-same-page-using-vuetify
    var options = {
      offset: 102,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#login_form_top", options);
  },
  methods: {
    login_success(){
      //do nothing for now
    }
  },
};
</script>

